import type { VehicleType } from '@raahi/shared';

interface Option {
  type: VehicleType;
  label: string;
  caption: string;
}

const OPTIONS: Option[] = [
  { type: 'bike', label: 'Bike', caption: 'Beat the traffic' },
  { type: 'economy', label: 'Economy', caption: 'Affordable, AC' },
  { type: 'premium', label: 'Premium', caption: 'Newer cars' },
];

interface Props {
  value: VehicleType;
  onChange: (type: VehicleType) => void;
  fares?: Partial<Record<VehicleType, number>>;
}

export function VehicleTypePicker({ value, onChange, fares }: Props) {
  return (
    <div role="radiogroup" aria-label="Vehicle type" className="grid grid-cols-3 gap-2">
      {OPTIONS.map((opt) => {
        const selected = opt.type === value;
        const fare = fares?.[opt.type];
        return (
          <button
            key={opt.type}
            role="radio"
            aria-checked={selected}
            onClick={() => onChange(opt.type)}
            className={
              'flex flex-col items-start rounded-2xl border px-3 py-3 text-left transition ' +
              (selected ? 'border-ink bg-ink/5' : 'border-line bg-white hover:border-ink/40')
            }
          >
            <span className="font-display text-base font-semibold">{opt.label}</span>
            <span className="text-xs text-muted">{opt.caption}</span>
            <span className="num mt-1 text-sm font-semibold text-ink">
              {fare != null ? `Rs ${fare.toLocaleString('en-PK')}` : <span className="text-muted">—</span>}
            </span>
          </button>
        );
      })}
    </div>
  );
}
